import React from 'react';

export default (props) => {
    return (
        <div className="hero">
            <h1>{props.title}</h1>
            <span>{props.subtitle}</span>
        </div>
    )
}